import { Field, Formik } from "formik";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import * as Yup from 'yup';
import Put from "../../api/Put";
import { APPOINTMENT_UPDATE_ONDEMAND, PACIENTERELACION_GET_ACTIVE } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import SimpleLoad from "../../loader/SimpleLoad";
import DatePicker from 'react-datepicker'
import Get from "../../api/Get";
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import { checkSpecialityToShowIMC } from "../../utils/checkSpecialityToShow";


function CompletePatientInfo({t, cita, setCita, emailPatient, setShowFormPatient}){
    const { auth } = useContext(authContext)
    const [dateOfBirthday, setDateOfBirthday] = useState(null)
    const [tipoPacientes, setTipoPacientes] = useState([])
    const [phone, setPhone] = useState('')

    useEffect(()=>{
        Get({url: PACIENTERELACION_GET_ACTIVE, access_token: auth.data.access_token})
        .then(response=>{
            //console.log(response)
            setTipoPacientes(response.data.data.response)
        })
        .catch(error=>{
            console.log(error)
        })
    },[])

    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        lastName: '',
        dateOfBirthday: '',
        phoneNumber: '',
        email: emailPatient,
        address: '',
        company: '',
        externalId: '',
        motivoConsulta: '',
        peso: '',
        talla: '',
        gender: '',
        patientRelationship: ''
    })

    const shemaValidate = Yup.object().shape({
        name: Yup.string()
          .required(t('Camporequerido')),
        lastName: Yup.string()
          .required(t('Camporequerido')),
        patientRelationship: Yup.string()
          .required(t('Camporequerido')),
        dateOfBirthday: Yup.string()
          .required(t('Camporequerido')),
        phoneNumber: Yup.string() 
          .required(t('Camporequerido'))
          .min(12,'Campo inválido')
          .max(12,'Campo inválido'),
        email: Yup.string()
           .email(t('Correoinvalido'))
           .required(t('Camporequerido')),
        address: Yup.string()
           .required(t('Camporequerido')),
        motivoConsulta: Yup.string()
           .required(t('Camporequerido')),
        gender: Yup.string()
          .required(t('Camporequerido')),
        
    });


    return (
        <Card className="shadow-1">
            <Card.Body>
                <Alert variant="info">No se ha encontrado el paciente</Alert>
                <Formik
                    initialValues={initialValues}
                    validationSchema={shemaValidate}
                    onSubmit={(values, { setSubmitting, setFieldValue }) => { 
                        let d = {
                            id: cita.id,
                            appointmentStatus: "Pagada",
                            patient: {
                              id: cita.patientDTO.id,
                              email: values.email,
                              lastName: values.lastName,
                              name: values.name,
                              phoneNumber: values.phoneNumber,
                              externalId: values.externalId,
                              address: values.address,
                              dateOfBirthday: moment(values.dateOfBirthday).format('DD-MM-YYYY'),
                              gender: values.gender,
                              account: cita.patientDTO.account,
                              patientRelationship: {id: values.patientRelationship}
                            },
                            peso: values.peso,
                            talla: values.talla,
                            motivoConsulta: values.motivoConsulta
                        }      
                        console.log(d)  
                        
                        Put({url: APPOINTMENT_UPDATE_ONDEMAND,data: d, access_token: auth.data.access_token, header: true})
                        .then(response=>{
                            console.log(response)
                            setShowFormPatient(false)
                            setCita(prev=>({
                                ...prev,
                                age: response.data.data.age,
                                peso: response.data.data.peso,
                                talla: response.data.data.talla,
                                motivoConsulta: response.data.data.motivoConsulta,
                                patientDTO: response.data.data.patientDTO
                            }))
                        })
                        .catch(error=>{
                            console.log(error)
                        })
                        
                    }}
                >{({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    setFieldError
                }) => (
                    <Form onSubmit={handleSubmit}  className='mt-3 position-relative'>
                        { isSubmitting && <SimpleLoad /> }
                            <Row>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Nombre')} <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.name && 'error'}`}
                                            name="name"
                                        />
                                        { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Apellidos')} <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.lastName && 'error'}`}
                                            name="lastName"
                                        />
                                        { errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Tipo <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            as="select"
                                            className={`form-control input-form ${errors.patientRelationship && 'error'}`}
                                            name="patientRelationship"
                                        >
                                            <option value="">Seleccionar</option>
                                            {
                                                tipoPacientes.map((item,i)=>(
                                                    <option key={i} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        { errors.patientRelationship && <div className="invalid-feedback d-block">{errors.patientRelationship}</div> }
                                    </Form.Group>
                                </Col>                                
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary d-block">{t("fecha_nacimiento")} <span className="text-danger">*</span></Form.Label>
                                        <DatePicker 
                                            className={`form-control input-form w-100 ${errors.dateOfBirthday && 'error'}`}
                                            selected={dateOfBirthday} 
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={new Date()}
                                            onChange={date => {
                                                if(date===null){
                                                    setDateOfBirthday(null)
                                                    setFieldValue('dateOfBirthday', '')
                                                }else{
                                                    setDateOfBirthday(date)
                                                    setFieldValue('dateOfBirthday', date)
                                                }
                                                
                                            }} />                                            
                                        { errors.dateOfBirthday && <div className="invalid-feedback d-block">{errors.dateOfBirthday}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">No. poliza</Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.externalId && 'error'}`}
                                            name="externalId"
                                        />
                                        <Form.Text muted>Este campo no es obligatorio</Form.Text>
                                        { errors.externalId && <div className="invalid-feedback d-block">{errors.externalId}</div> }
                                    </Form.Group>
                                </Col> 
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Telefono')} <span className="text-danger">*</span></Form.Label>
                                        <PhoneInput
                                            inputClass={`form-control input-form ${errors.phoneNumber && 'error'} w-100`}
                                            country={'mx'}
                                            countryCodeEditable={false}
                                            enableSearch={true}
                                            preferredCountries={['mx', 'co']}
                                            disableSearchIcon={true}
                                            localization={es}
                                            value={phone}
                                            onChange={(phone, country, e, formattedValue) => {
                                                setPhone(phone)
                                                setFieldValue('phoneNumber', phone)
                                                let validNumber = (country.format.match(/\./g)).length
                                                if(phone.length !== validNumber){
                                                    setFieldError('phoneNumber', 'Campo inválido')
                                                }else if(phone.length === validNumber){
                                                    setFieldValue('phoneNumber', phone, true)
                                                }                                                
                                            }}
                                        />
                                        { errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('sexo')} <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            as="select"
                                            className={`form-control input-form ${errors.gender && 'error'}`}
                                            name="gender"
                                        >
                                            <option value="">Seleccionar</option>
                                            <option value="Male">{t('Masculino')}</option>
                                            <option value="Female">{t('Femenino')}</option>
                                        </Field>
                                        { errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Correoelectronico')} <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.email && 'error'}`}
                                            name="email"
                                        />
                                        { errors.email && <div className="invalid-feedback d-block">{errors.email}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('direccion')}</Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.address && 'error'}`}
                                            name="address"
                                        />
                                        { errors.address && <div className="invalid-feedback d-block">{errors.address}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{'Motivo consulta'} <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.motivoConsulta && 'error'}`}
                                            name="motivoConsulta"
                                        />
                                        { errors.motivoConsulta && <div className="invalid-feedback d-block">{errors.motivoConsulta}</div> }
                                    </Form.Group>
                                </Col>
                                {checkSpecialityToShowIMC(cita) && <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{'Peso'} (Kg)</Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.peso && 'error'}`}
                                            name="peso"
                                        />
                                        {/* { errors.peso && <div className="invalid-feedback d-block">{errors.peso}</div> } */}
                                    </Form.Group>
                                </Col>}
                                {checkSpecialityToShowIMC(cita) && <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{'Talla'} (cm)</Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.talla && 'error'}`}
                                            name="talla"
                                        />
                                        {/* { errors.talla && <div className="invalid-feedback d-block">{errors.talla}</div> } */}
                                    </Form.Group>
                                </Col>}
                            </Row>
                            <Row>
                                <Col className="text-right">
                                    <Button variant="outline-success" className="ok-buttom" type="submit">Aceptar</Button>{' '}
                                </Col>
                            </Row>
                    </Form>
                )}
                </Formik>
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(CompletePatientInfo)